import { getYear } from 'date-fns';
import { Link, usePathname } from 'expo-router';
import React from 'react';
import { Platform, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { isDesktop } from '@/core';
import { Text } from '@/ui';

const categories = [
  {
    title: 'Cars',
    items: [
      {
        title: 'Cybertruck',
        href: 'https://www.eonrides.com/tesla-rentals/cybertruck',
      },
      {
        title: 'Model 3',
        href: 'https://www.eonrides.com/tesla-rentals/model-3',
      },
      {
        title: 'Model Y',
        href: 'https://www.eonrides.com/tesla-rentals/model-y',
      },
      {
        title: 'Model X',
        href: 'https://www.eonrides.com/tesla-rentals/model-x',
      },
      {
        title: 'Model S',
        href: 'https://www.eonrides.com/tesla-rentals/model-s',
      },
    ],
  },
  {
    title: 'Support',
    items: [
      {
        title: 'FAQ',
        href: '/account/support-faq',
      },
    ],
  },
  {
    title: 'Locations',
    items: [
      {
        title: 'Atlanta, GA',
        href: 'https://teslarents.com/atlanta',
      },
      {
        title: 'Austin, TX',
        href: 'https://teslarents.com/austin',
      },
      {
        title: 'Boston, MA',
        href: 'https://teslarents.com/boston',
      },
      {
        title: 'Chicago, IL',
        href: 'https://teslarents.com/chicago',
      },
      {
        title: 'Dallas, TX',
        href: 'https://teslarents.com/dallas',
      },
      {
        title: 'Houston, TX',
        href: 'https://teslarents.com/houston',
      },
      {
        title: 'Kansas City, MO',
        href: 'https://teslarents.com/kansas-city',
      },
      {
        title: 'Miami, FL',
        href: 'https://teslarents.com/miami',
      },
      {
        title: 'New York, NY',
        href: 'http://www.eonrides.com/tesla-rentals/new-york-city',
      },
      {
        title: 'Nashville, TN',
        href: 'https://teslarents.com/nashville',
      },
      {
        title: 'Phoenix, AZ',
        href: 'https://teslarents.com/phoenix',
      },
      {
        title: 'Las Vegas, NV',
        href: 'https://teslarents.com/las-vegas',
      },
      {
        title: 'Los Angeles, CA',
        href: 'http://www.eonrides.com/tesla-rentals/los-angeles',
      },
      {
        title: 'San Diego, CA',
        href: 'https://teslarents.com/san-diego',
      },
      {
        title: 'San Jose, CA',
        href: 'https://teslarents.com/san-jose',
      },
      {
        title: 'San Francisco, CA',
        href: 'http://www.eonrides.com/tesla-rentals/san-francisco',
      },
      {
        title: 'Seattle, WA',
        href: 'https://teslarents.com/seattle',
      },
      {
        title: 'San Antonio, TX',
        href: 'https://teslarents.com/san-antonio',
      },
      {
        title: 'St Louis, MO',
        href: 'https://teslarents.com/st-louis',
      },
      {
        title: 'Washington, DC',
        href: 'https://teslarents.com/washington-dc',
      },
    ],
  },
  {
    title: 'Quick links',
    items: [
      {
        title: 'Electric car Subscription',
        href: 'https://www.eonrides.com/electric-car-subscription',
      },
      {
        title: 'Tesla Subscription',
        href: 'https://www.eonrides.com/tesla-car-subscription',
      },
      {
        title: 'Business Car leasing',
        href: 'https://www.eonrides.com/business-car-leasing',
      },
      {
        title: 'Business Car Rental',
        href: 'https://teslarents.com/business-car-rental',
      },
      {
        title: 'Corporate Car leasing',
        href: 'https://www.eonrides.com/corporate-car-leasing',
      },
      {
        title: 'Electric car rental',
        href: 'http://www.eonrides.com/car-rental/electric-car-rental',
      },
      {
        title: 'Tesla Rental',
        href: 'https://www.eonrides.com/tesla-rentals',
      },
    ],
  },
];

export default function Footer() {
  const { theme } = useStyles();
  const pathname = usePathname();

  if (Platform.OS !== 'web') {
    return null;
  }

  if (!isDesktop() && pathname === '/') {
    return (
      <View
        style={{
          width: '100%',
          backgroundColor: theme.colors.background_1,
          borderTopColor: theme.colors.card.default.borderColor,
          borderTopWidth: 1,
          gap: 16,
          padding: 16,
        }}
      >
        <View
          style={{
            flexDirection: 'column',
            gap: 16,
          }}
        >
          <Link href="https://www.eonrides.com/legal/terms-privacy-policy">
            <Text type="caption1">Privacy Policy</Text>
          </Link>

          <Text type="caption1" style={{ color: theme.colors.text.secondary }}>
            {getYear(new Date())} eonrides.com. All rights reserved
          </Text>
        </View>
      </View>
    );
  }

  if (!isDesktop()) return null;

  return (
    <View
      style={{
        height: 600,
        width: '100%',
        backgroundColor: theme.colors.background_1,
        borderTopColor: theme.colors.card.default.borderColor,
        borderTopWidth: 1,
        gap: 16,
      }}
    >
      <View style={{ flexGrow: 1, alignItems: 'center', paddingTop: 40 }}>
        <View style={{ flexDirection: 'row', gap: 60 }}>
          {categories.map((category) => {
            return (
              <View key={category.title} style={{ gap: 8 }}>
                <Text type="bodyBold">{category.title}</Text>

                <View style={{ gap: 8 }}>
                  {category.items.map((item) => {
                    return (
                      <Link key={item.title} href={item.href}>
                        <Text
                          type="caption1"
                          style={{ color: theme.colors.text.secondary }}
                        >
                          {item.title}
                        </Text>
                      </Link>
                    );
                  })}
                </View>
              </View>
            );
          })}

          <View style={{ gap: 16 }}>
            <View style={{ gap: 8 }}>
              <Text type="bodyBold">About us</Text>

              <View style={{ gap: 8, width: 300 }}>
                <Text
                  type="caption1"
                  style={{ color: theme.colors.text.secondary }}
                >
                  Eon is the leading EV car rental company in the US, providing
                  customers with an unmatched driving experience.
                </Text>
              </View>
            </View>

            <View style={{ gap: 8 }}>
              <Text type="bodyBold">Subscribe</Text>

              <View style={{ gap: 8, width: 300 }}>
                <Text
                  type="caption1"
                  style={{ color: theme.colors.text.secondary }}
                >
                  Sign up for last minute deals and special announcements!
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>

      <View
        style={{
          borderTopColor: theme.colors.card.default.borderColor,
          borderTopWidth: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: 50,
          paddingLeft: 16,
          paddingRight: 16,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            gap: 16,
            alignItems: 'center',
          }}
        >
          <Text type="caption1" style={{ color: theme.colors.text.secondary }}>
            {getYear(new Date())} eonrides.com. All rights reserved
          </Text>

          <Link href="https://www.eonrides.com/legal/terms-privacy-policy">
            <Text type="caption1">Privacy Policy</Text>
          </Link>
        </View>

        <View
          style={{
            flexDirection: 'row',
            gap: 16,
            alignItems: 'center',
          }}
        >
          <Link href="https://www.instagram.com/eonrides">
            <Text type="bodyRegular">Instagram</Text>
          </Link>
        </View>
      </View>
    </View>
  );
}
